"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsRouter = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _DmsUnderDevelopment = require("../../pages/DmsUnderDevelopment/DmsUnderDevelopment");
var _DmsLogin = require("../../pages/DmsLogin/DmsLogin");
var _NamedRoutes = require("../../constants/NamedRoutes");
var _DmsTokenHook = require("../DmsTokenHook/DmsTokenHook");
var _DmsPageNotFound = require("../../pages/DmsPageNotFound/DmsPageNotFound");
var _DmsAccessDenied = require("../../pages/DmsAccessDenied/DmsAccessDenied");
var _useDmsMultipleTabsToken = require("../../Hooks/useDmsMultipleTabsToken");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsRouter Component
 * 
 * @description This component handles the routing logic for the application. 
 * It manages both public and private routes, ensuring that users are redirected to 
 * the login page if they are not authenticated and trying to access private routes.
 * 
 * @component
 * @param {Object} props - The component props
 * @param {React.ReactNode} [props.publicContent=null] - The content to be rendered for public routes.
 * @param {React.ReactNode} [props.privateContent=null] - The content to be rendered for private routes.
 * @param {boolean} [props.virtualKeyboard=false] - Indicates whether the virtual keyboard should be enabled for login.
 * @param {boolean} [props.automaticRoute=false] - Indicates whether an automatic login button should be shown.
 * 
 * @example
 * <DmsRouter 
 *   publicContent={<PublicComponent />} 
 *   privateContent={<PrivateComponent />} 
 *   virtualKeyboard={true}
 *   automaticRoute={false}
 * />
 * 
 * @returns {JSX.Element} The rendered routes of the application.
 */

const DmsRouter = _ref => {
  let {
    publicContent = null,
    privateContent = null,
    virtualKeyboard = false,
    automaticRoute = false
  } = _ref;
  const {
    token,
    setToken
  } = (0, _DmsTokenHook.useToken)();
  (0, _useDmsMultipleTabsToken.useDmsMultipleTabsToken)(token, setToken);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    element: !token ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Navigate, {
      to: _NamedRoutes.ROUTES.Login
    }) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Outlet, null)
  }, privateContent), publicContent, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _NamedRoutes.ROUTES.Login,
    element: !token ? /*#__PURE__*/_react.default.createElement(_DmsLogin.DmsLogin, {
      setToken: setToken,
      authentication_url: "/token",
      virtualKeyboard: virtualKeyboard,
      showAutomaticButton: automaticRoute
    }) : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Navigate, {
      to: _NamedRoutes.ROUTES.Home
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/underDevelopment",
    element: /*#__PURE__*/_react.default.createElement(_DmsUnderDevelopment.DmsUnderDevelopment, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "/access-denied",
    element: /*#__PURE__*/_react.default.createElement(_DmsAccessDenied.DmsAccessDenied, null)
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "*",
    element: /*#__PURE__*/_react.default.createElement(_DmsPageNotFound.DmsPageNotFound, null)
  })));
};
exports.DmsRouter = DmsRouter;